// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"


const scrollTopOnTurbo = () => window.scrollTo(0, 0);

document.addEventListener("turbo:load", scrollTopOnTurbo);
document.addEventListener("turbo:render", scrollTopOnTurbo);

